import styled from "styled-components";

export const StyledError = styled.div`
  position: relative;
  padding-top: 201.3px;
  margin: auto;
  min-height: calc(100vh - 67px);
  z-index: 1000;

  @media (max-width: 900px) {
    min-height: calc(100vh);
    padding-top: 178px;
  }

  @media (max-width: 360px) {
    padding-top: 98px;
  }

  .header {
    background: white;
  }

  .error {
    font-weight: normal;
    font-size: 165.934px;
    line-height: 146px;
    text-transform: uppercase;
    color: ${(p) => p.theme.colors.primary};
    margin-top: 0;
    margin-bottom: 52.7px;

    @media (max-width: 900px) {
      font-size: 85px;
      line-height: 81px;
      margin-bottom: 13px;
    }
  }

  .error-title {
    font-weight: 500;
    font-size: 22px;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #000000;
    margin-top: 0;
    margin-bottom: 14px;

    @media (max-width: 900px) {
      font-size: 20px;
      line-height: 31px;
      margin-bottom: 7px;
    }
  }

  .c-text {
    font-size: 18px;
    line-height: 24px;
    margin: 0 auto 38px;

    @media (max-width: 900px) {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }

  .btns {
    display: flex;
    flex-direction: row;
    justify-content: center;

    a:hover {
      text-decoration: none;
    }
  }

  .btn-go-home {
    border-radius: 4px;
    width: 162px !important;
    height: 48px !important;
    padding: 13px 20px;
    margin-left: 16px;
    background-color: ${(p) => p.theme.colors.white};
    color: #232819;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    box-shadow: ${(p) => (p.$isSolid ? "0 0 0 1.4px #d0d1d2" : "none")};

    @media (max-width: 900px) {
      padding: 10px 16px;
      box-shadow: 0 0 0 1.4px #d0d1d2;
      height: 32px !important;
      width: 113px !important;
      white-space: nowrap;
      border-radius: 50px;
      font-size: 14px;
    }

    svg {
      width: 24px;
      height: 24px;
      margin-right: 8px;

      @media (max-width: 900px) {
        margin-right: 4px;
      }
    }

    &:hover {
      background-color: ${(p) => p.theme.colors.primary};
      color: ${(p) => p.theme.colors.white};
      box-shadow: none;
    }

    &--colored {
      background-color: ${(p) => p.theme.colors.primary};
      color: ${(p) => p.theme.colors.white};
      border-color: transparent;
      box-shadow: none;

      &:hover {
        background-color: ${(p) => p.theme.colors.primaryDark20};
      }
    }
  }

  .site {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #000;

    @media (max-width: 900px) {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const StyledBody = styled.div`
  text-align: center;
  padding-bottom: 300px;

  @media (max-width: 900px) {
    min-height: fit-content;
    padding: 0 48px;
    padding-bottom: 500px;
  }

  @media (max-width: 377px) {
    min-height: 540px !important;
  }
  /* margin-bottom: 100px; */
`;
